import React from "react";

import { useID } from "~/lib/hooks";

export default function MicrosoftTodoLogo({
	className,
	style,
}: React.PropsWithoutRef<{ className?: string; style?: React.CSSProperties }>) {
	const linearGradient1 = useID();

	return (
		<svg
			className={className}
			style={style}
			width="40"
			height="32"
			viewBox="0 0 40 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				// eslint-disable-next-line max-len
				d="M6.81944 9.18056L1.18056 14.8194C0.528553 15.4714 0.528553 16.5286 1.18056 17.1806L14.8194 30.8194C15.4714 31.4714 16.5286 31.4714 17.1806 30.8194L22.8194 25.1806C23.4714 24.5286 23.4714 23.4714 22.8194 22.8194L9.18055 9.18056C8.52855 8.52855 7.47145 8.52855 6.81944 9.18056Z"
				fill="#185ABD"
			/>
			<path
				// eslint-disable-next-line max-len
				d="M38.8196 6.81944L33.1807 1.18056C32.5287 0.528554 31.4716 0.528553 30.8196 1.18056L9.18068 22.8194C8.52868 23.4714 8.52868 24.5286 9.18068 25.1806L14.8196 30.8194C15.4716 31.4714 16.5287 31.4714 17.1807 30.8194L38.8196 9.18056C39.4716 8.52855 39.4716 7.47145 38.8196 6.81944Z"
				fill={`url(#${linearGradient1})`}
			/>
			<defs>
				<linearGradient id={linearGradient1} x1="12.0001" y1="28" x2="36.0001" y2="4" gradientUnits="userSpaceOnUse">
					<stop stopColor="#2987E6" />
					<stop offset="0.994" stopColor="#58C1F5" />
				</linearGradient>
				<linearGradient id={linearGradient1} x1="12.0001" y1="28" x2="36.0001" y2="4" gradientUnits="userSpaceOnUse">
					<stop stopColor="#2987E6" />
					<stop offset="0.994" stopColor="#58C1F5" />
				</linearGradient>
			</defs>
		</svg>
	);
}
